var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_vm._v("New Role")]),(_vm.form)?_c('Form',{attrs:{"submit":_vm.create,"btnText":"Add Role"},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}):_c('Spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }